<template>
  <div
    class="stat-card-white"
    ref="captureArea"
    :class="{ 'chart-empty-state': !loader && !series.length }"
  >
 
    <!-- Header -->
    <div class="stat-header-white d-flex justify-content-between align-items-center">
 
      <span>{{ chartLabel }}</span>
 
      <div class="d-flex align-items-center">
 
        <!-- Table -->
        <div
          class="expand-block px-2 mb-1 cursor-pointer position-relative"
          @click="showtable"
        >
          <img src="../../assets/img/table_view.png" />
 
          <div class="more-expand">
            <span>Data Overview</span>
          </div>
        </div>
 
        <!-- Expand -->
        <div
          class="expand-block px-2 mb-1 cursor-pointer"
          @click.prevent="expandBlock = true"
        >
          <img src="../../assets/img/expand.png" />
        </div>
 
        <!-- More -->
        <div
          class="text-center"
          v-on:clickout="showPopup = false"
        >
 
          <div
            class="position-relative cursor-pointer biggerfont ml-2"
            @click.prevent="showPopup = !showPopup"
          >
            <i class="fa fa-ellipsis-v"></i>
          </div>
 
          <div
            class="plan-side-popup"
            ref="excludeThis"
            v-if="showPopup"
          >
 
            <div
              @click.prevent="showPopup = false; exportToExcel()"
            >
              Export to Excel
            </div>
 
            <div
              @click.prevent="showPopup = false; exportToPdf()"
            >
              Export to PDF
            </div>
 
          </div>
 
        </div>
 
      </div>
 
    </div>
 
    <!-- Body -->
    <div class="stat-body-white d-flex flex-column">
 
      <!-- Loader -->
      <div
        v-if="loader"
        class="loader-wrapper"
      >
        <div class="loader"></div>
      </div>
 
      <!-- Chart -->
      <div
        v-else-if="series.length"
        class="chart-container"
      >
 
        <!-- Drill-down action bar -->
        <div
          v-if="selectedGroups.length"
          class="selectdrill d-flex flex-row-reverse gap-2 w-100 mb-2"
        >
 
          <img
            class="cursor-pointer"
            src="../../assets/img/chart_cancel.png"
            @click.prevent="cancelSelection"
            alt="Cancel"
          />
 
          <img
            class="cursor-pointer"
            src="../../assets/img/chart_submit.png"
            @click.prevent="recreateChart"
            alt="Submit"
          />
 
        </div>
 
        <apexchart
          ref="mainChart"
          :key="chartKey"
          type="donut"
          :height="chartHeight"
          :options="chartOptions"
          :series="series"
        />
 
      </div>
 
      <!-- Empty -->
      <div
        v-else
        class="hpb-empty"
      >
        No data available
      </div>
 
    </div>
 
  </div>
 
  <!-- Expand Popup -->
  <enlargerpopup
    v-if="expandBlock"
    @closeModal="expandBlock = false"
  >
 
    <div class="popupheight d-flex flex-column col-md-12">
 
      <!-- Drill-down action bar -->
      <div
        v-if="selectedGroups.length"
        class="selectdrill d-flex flex-row-reverse gap-2 w-100 mb-2"
      >
 
        <img
          class="cursor-pointer"
          src="../../assets/img/chart_cancel.png"
          @click.prevent="cancelSelection"
          alt="Cancel"
        />
 
        <img
          class="cursor-pointer"
          src="../../assets/img/chart_submit.png"
          @click.prevent="recreateChart"
          alt="Submit"
        />
 
      </div>
 
      <div class="chart-container popupconatiner">
 
       <apexchart
          ref="popupChart"
          :key="'popup-' + chartKey"
          type="donut"
          :height="popupHeight"
          :options="chartOptions"
          :series="series"
        />
 
      </div>
 
    </div>
 
  </enlargerpopup>
</template>
 
<script>
import VueApexCharts from "vue3-apexcharts";
import enlargerpopup from "../AiCharts/popupfiles/enlarge_popup.vue";
import * as XLSX from "xlsx";
import html2pdf from "html2pdf.js";
 
const DEFAULT_COLORS = [
  "#4472C4",
  "#ED7D31",
  "#A5A5A5",
  "#FFC000",
  "#5B9BD5",
  "#70AD47",
  "#C00000"
];
 
export default {
 
  name: "donutchart",
 
  components: {
    apexchart: VueApexCharts,
    enlargerpopup
  },
 
  props: {
 
    loader: {
      type: Boolean,
      default: false
    },
 
    dataArray: {
      type: Array,
      default: () => []
    },
 
    groupField: {
      type: String,
      required: true
    },
 
    chartLabel: {
      type: String,
      default: ""
    },
 
    height: {
      type: Number,
      default: 340
    },
 
    colors: {
      type: Array,
      default: () => []
    }
  },
 
  emits: [
    "opendrillpopup",
    "drilldowncurrentchart"
  ],
 
  data() {
 
    return {
 
      showPopup: false,
      expandBlock: false,
      chartKey: 0,
      bindSlicesTimer: null,
 
      series: [],
      labels: [],
      groupedRows: {},
 
      selectedGroups: [],
      sortdata: [],
      filterarray: [],
      filterkeyword: ""
    };
  },
 
  computed: {
 
    chartHeight() {
      return this.height;
    },
 
    popupHeight() {
      return 500;
    },
 
    palette() {
 
      return this.colors.length
        ? this.colors
        : DEFAULT_COLORS;
    },
 
    chartOptions() {
 
      return {
 
        chart: {
 
          type: "donut",
 
          events: {
            mounted: () => {
              this.queueBindSliceClicks();
            },
            updated: () => {
              this.queueBindSliceClicks();
            }
          }
        },
 
        labels: this.labels,
 
        colors: this.labels.map(
          (label, index) => {
 
            const base =
              this.palette[
                index % this.palette.length
              ];
 
            if (
              !this.selectedGroups.length
            ) {
              return base;
            }
 
            return this.selectedGroups.includes(label)
              ? base
              : `${base}50`;
          }
        ),
 
        legend: {
          position: "bottom"
        },
 
        dataLabels: {
          enabled: true
        },
 
        tooltip: {
          y: {
            formatter: function(val) {
              return val + " AEs";
            }
          }
        },
 
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: "100%"
              },
              legend: {
                position: "bottom"
              }
            }
          }
        ],
 
        plotOptions: {
          pie: {
            donut: {
              size: "55%"
            }
          }
        },
 
        states: {
          active: {
            allowMultipleDataPointsSelection: true
          }
        }
      };
    }
  },
 
  watch: {
 
    dataArray: {
 
      immediate: true,
 
      handler() {
        this.prepareChart();
      }
    },
    loader(newValue) {
      if (!newValue) {
        this.$nextTick(() => this.queueBindSliceClicks());
      }
    },
    expandBlock(newValue) {
      if (newValue) {
        this.$nextTick(() => this.queueBindSliceClicks());
      }
    }
  },
 
  methods: {

    resetSelection() {
      this.selectedGroups = [];
      this.sortdata = [];
      this.filterarray = [];
      this.filterkeyword = "";
    },

    forceChartRefresh() {
      this.chartKey += 1;
      this.$nextTick(() => this.queueBindSliceClicks());
    },

    queueBindSliceClicks() {
      if (this.bindSlicesTimer) {
        clearTimeout(this.bindSlicesTimer);
      }

      this.bindSlicesTimer = setTimeout(() => {
        this.bindSlicesTimer = null;
        this.bindSliceClicks();
      }, 0);
    },

    bindSliceClicks() {
      this.bindClicksForChartRef(this.$refs.mainChart);

      if (this.expandBlock) {
        this.bindClicksForChartRef(this.$refs.popupChart);
      }
    },

    bindClicksForChartRef(chartRef) {
      const root =
        chartRef && chartRef.$el
          ? chartRef.$el
          : chartRef;

      if (!root || typeof root.querySelectorAll !== "function") {
        return;
      }

      const nodes = root.querySelectorAll(
        ".apexcharts-series path, .apexcharts-data-labels text"
      );

      nodes.forEach((node, index) => {
        const sliceIndex = this.resolveSliceIndex(node, index);

        if (sliceIndex < 0) {
          return;
        }

        node.style.cursor = "pointer";
        node.onclick = (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.handleSliceIndex(sliceIndex);
        };
      });
    },

    resolveSliceIndex(node, fallbackIndex) {
      const seriesNode = node.closest
        ? node.closest(".apexcharts-series")
        : null;

      if (
        seriesNode &&
        seriesNode.getAttribute &&
        seriesNode.getAttribute("rel")
      ) {
        const rel = Number(seriesNode.getAttribute("rel"));

        if (!Number.isNaN(rel)) {
          return rel - 1;
        }
      }

      if (
        node.parentElement &&
        node.parentElement.classList &&
        node.parentElement.classList.contains("apexcharts-data-labels")
      ) {
        const labelNodes = Array.from(
          node.parentElement.querySelectorAll("text")
        );
        return labelNodes.indexOf(node);
      }

      return fallbackIndex < this.labels.length
        ? fallbackIndex
        : -1;
    },

    handleSliceIndex(index) {
      if (index < 0 || index >= this.labels.length) {
        return;
      }

      const label = this.labels[index];

      if (label) {
        this.onDonutClick(label);
      }
    },
 
 
 onDonutClick(label) {
 
  const rows =
    this.groupedRows[label]?.rows || [];
 
  if (
    this.selectedGroups.includes(label)
  ) {
 
    this.selectedGroups =
      this.selectedGroups.filter(
        x => x !== label
      );
 
    this.sortdata =
      this.sortdata.filter(
        r => !rows.includes(r)
      );
 
  } else {
 
    this.selectedGroups.push(label);
 
    this.sortdata = [
      ...this.sortdata,
      ...rows
    ];
  }
 
  this.filterkeyword =
    `${this.groupField}(${this.selectedGroups.join(",")})`;
 
  this.forceChartRefresh();
},
 
 
    cancelSelection() {
 
      this.resetSelection();
      this.forceChartRefresh();
    },
 
    /* =========================================
       SUBMIT DRILLDOWN
    ========================================= */
 
    recreateChart() {
 
      this.$emit(
        "drilldowncurrentchart",
        {
          sortedData: this.sortdata,
          filterkeyword: this.filterkeyword
        }
      );
    },
 
    /* =========================================
       PREPARE CHART
    ========================================= */
 
    prepareChart() {

      this.resetSelection();
 
      const grouped = {};
 
      this.dataArray.forEach(item => {
 
        const key =
          item[this.groupField] || "Unknown";
 
        if (!grouped[key]) {
 
          grouped[key] = {
            count: 0,
            rows: []
          };
        }
 
        grouped[key].count += 1;
 
        grouped[key].rows.push(item);
      });
 
      this.groupedRows = grouped;
 
      this.labels =
        Object.keys(grouped);
 
      this.series =
        Object.values(grouped).map(
          x => x.count
        );

      this.forceChartRefresh();
    },
 
    /* =========================================
       TABLE
    ========================================= */
 
    showtable() {
 
      this.$emit(
        "opendrillpopup",
        this.dataArray
      );
    },
 
    /* =========================================
       EXPORT EXCEL
    ========================================= */
 
    exportToExcel() {

      const excludedFields = ['id', 'subjectGuid'];

      const convertedData = this.dataArray.map(item => {

        const newItem = {};

        Object.keys(item).forEach(key => {

          // Remove unwanted fields
          if (excludedFields.includes(key)) {
            return;
          }

          // Convert camelCase -> Pascal Case with spaces
          const pascalKey = key
            .replace(/([A-Z])/g, ' $1')
            .replace(/^./, str => str.toUpperCase());

          newItem[pascalKey] = item[key];
        });

        return newItem;
      });

      const ws = XLSX.utils.json_to_sheet(convertedData);

      const wb = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(
        wb,
        ws,
        "Sheet1"
      );

      XLSX.writeFile(
        wb,
        `${this.chartLabel || "chart"}.xlsx`
      );
    },

    // exportToExcel() {
 
    //   const ws =
    //     XLSX.utils.json_to_sheet(
    //       this.dataArray
    //     );
 
    //   const wb =
    //     XLSX.utils.book_new();
 
    //   XLSX.utils.book_append_sheet(
    //     wb,
    //     ws,
    //     "Sheet1"
    //   );
 
    //   XLSX.writeFile(
    //     wb,
    //     `${this.chartLabel || "chart"}.xlsx`
    //   );
    // },
 
    /* =========================================
       EXPORT PDF
    ========================================= */
 
    exportToPdf() {
 
      const exclude =
        this.$refs.excludeThis;
 
      if (exclude) {
        exclude.style.display = "none";
      }
 
      const wrap =
        document.createElement("div");
 
      wrap.appendChild(
        this.$refs.captureArea.cloneNode(true)
      );
 
      html2pdf()
        .set({
 
          margin: 0,
 
          filename:
            `${this.chartLabel || "chart"}.pdf`,
 
          image: {
            type: "jpeg",
            quality: 0.98
          },
 
          html2canvas: {
            scale: 2
          },
 
          jsPDF: {
            unit: "pt",
            format: "a4",
            orientation: "landscape"
          }
        })
        .from(wrap)
        .save();
    }
  },

  beforeUnmount() {
    if (this.bindSlicesTimer) {
      clearTimeout(this.bindSlicesTimer);
      this.bindSlicesTimer = null;
    }
  }
};
</script>
 
<style scoped>
@import "../../custom_lib/AiCharts/charts.css";
 
.chart-container {
  width: 100%;
}
 
.popupconatiner {
  z-index: 10000;
}
 
.hpb-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 120px;
  font-size: 13px;
  color: #999;
}
 
.loader {
  border: 6px solid #f3f3f3;
  border-top: 6px solid #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin: 0 auto;
}
 
.loader-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 340px;
  width: 100%;
}
 
.selectdrill img {
  width: 22px;
  height: 22px;
}
 
@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}
</style>
 
